import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.TwoFaHardEnforcementPage.HardEnforcementStart.ConfirmPasskey', {
    title: 'Confirm passkey',
    description: 'Please, log in with passkey you just added',
});
